import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CollapseModule } from '../collapse/collapse.module';
import { IconModule } from '../icon/icon.module';
import { AccordionCardComponent } from './accordion-card.component';

@NgModule({
  declarations: [AccordionCardComponent],
  imports: [CommonModule, IconModule, CollapseModule],
  exports: [AccordionCardComponent],
})
export class AccordionCardModule {}
